
export const api = {
    affiliations: '/api/affiliations',
    aideType: '/api/aide_types',
    aideSousType: '/api/aide_sous_types',
    aideSettings: '/api/aide_settings',
    aides: '/api/aides',
    aidesClone: '/api/aides/{id}/clone',
    aidesBlocs: '/api/aide_blocs',
    aideEtapes: '/api/aide_etapes',
    aideBloc: '/api/aide_blocs',
    aideTranslations: '/api/aide_translations',
    voirAide: '/{langue}/aides/{id}?fullHtml={fullHtml}',
    cnrs: '/api/unite_cnrs',
    commissionType: '/api/commission_types',
    countries: '/api/countries',
    contacts: '/api/contacts',
    discipline: '/api/disciplines',
    fichier: '/api/fichiers',
    fields: '/api/fields',
    fieldParamValue: '/api/field_param_values',
    fieldParam: '/api/field_params',
    fieldTags : '/api/field_tags',
    fieldTranslation: '/api/field_translations',
    formulaireSaisie: '/api/formulaire_saisies',
    fieldType: '/api/field_types',
    fieldValue: '/api/field_values',
    forgotPasswordRequest: '/api/utilisateurs_actions/forgot_password',
    inserm: '/api/unite_inserms',
    laboratoires: '/api/laboratoires',
    laboratoiresReferences: '/api/laboratoire_references',
    laboratoireReferenceSuggestion: '/api/laboratoire_reference_suggestions',
    localisations: '/api/localisation_scs',
    login: '/api/login',
    projetDurees: '/api/projet_durees',
    resetPassword: '/api/utilisateurs_actions/reset_password',
    statutChercheur: '/api/statut_chercheurs',
    universiteFaculte: '/api/universite_facultes',
    utilisateur: '/api/utilisateurs',
    utilisateurvalidate: '/api/utilisateurs/validate_profile',
    utilisateurregister: '/api/utilisateurs_actions/register',
    utilisateurActionActivate: '/api/utilisateurs_actions/activate',
    utilsateurDesactivate: '/api/utilisateurs_actions/desactivate',
    utilsateurReactivate: '/api/utilisateurs_actions/reactivate',
    utilisateurChangeRole: '/api/utilisateurs_actions/change_droits',
    utilisateurType: '/api/utilisateur_types',
    roleUtilisateur: '/api/utilisateur_roles',
    commissions: '/api/commissions',
    commissionSeances: '/api/commission_seances',
    mandats: '/api/mandats',
    mandatType: '/api/mandat_types',
    TexteAdministrables: '/api/texte_administrables',
    createUtilisateurSignature: '/api/utilisateur_signatures',
    aideFormulaires: '/api/aides_formulaires',
    formulaires: '/api/formulaires',
    formulaireEtape: '/api/formulaire_etapes',
    formulaireEtapeTranslation: '/api/formulaire_etape_traslations',
    formulaireBlocs: '/api/formulaire_blocs',
    dossiers: '/api/dossiers',
    batch: '/api/dossiers/batch',
    batchDecision: '/api/decisions/batch',
    aideFormulaireFromAide: '/api/aides/{id}/aide_formulaires',
    declarationInterets: '/api/utilisateur_declaration_interets',
    voirDossier: '/{langue}/dossiers/{id}?fullHtml={fullHtml}',
    voirDossierEvaluation: '/{langue}/evaluations/{evaluation}/dossiers/{id}?fullHtml={fullHtml}',
    voirResumeDossier: '/{langue}/dossiers/resume/{id}',
    voirGrilleExpertise: '/{langue}/dossier_experts/{id}',
    voirDemandeProlongation: '/{langue}/demande_prolongations/{id}?fullHtml={fullHtml}',
    telechargerDossier: '/{langue}/dossiers/{id}/pdf?fullHtml={fullHtml}',
    dossierExpert: '/api/dossier_experts',
    activities: '/api/activities',
    publicationList: '/api/publication_lists',
    motCles: '/api/mot_cles',
    changementComissionSeance: '/api/dossiers/changement_commission_seance',
    financementAideTypes: '/api/financement_aide_types',
    financementDossier: '/api/financement_dossiers',
    financementRessourcesList: '/api/financement_ressources_lists',
    expertSaisieList: '/api/expert_saisie_lists',
    decisions: '/api/decisions',
    commissionSeanceParticipations: '/api/commission_seance_participations',
    mouvement: '/api/mouvements',
    expertSuggestion: '/api/dossier_expert_suggestions',
    reouvrirDossier: '/api/dossiers/{id}/reouvertureSaisieCandidat',
    reouvrirGrille: '/api/dossier_experts/repriseSaisie',
    seDesister: '/api/dossiers/desistementCandidat',
    adresses: '/api/adresses',
    dossierAnnexe: '/api/dossier_annexes',
    localisationInfos: '/api/localisation_infos',
    personneResponsable: '/api/personne_responsables',
    mailConfigurations: '/api/mail_configurations',
    equipeRecrutementList: '/api/equipe_recrutement_lists',
    equipeRecrutement: '/api/equipe_recrutements',
    etpEquipeList: '/api/etp_equipe_lists',
    organismeGestionnaire: '/api/organisme_gestionnaires',
    aideFraisTypes: '/api/aide_frais_types',
    demandeFinanciere: '/api/demande_financieres',
    dossierMouvement: '/api/dossier_mouvements',
    sendNotifs: '/api/decisions/notifier',
    experts: '/api/utilisateurs/experts',
    candidatures: '/api/utilisateurs/{id}/dossier_candidatures',
    exportColumns: '/api/export_columns',
    exportSelections: '/api/export_selections',
    contactEmailRequest: '/api/utilisateurs_actions/contact',
    metastases: '/api/localisation_metastases',
    dossierNonRecevable: '/api/dossiers/dossierNonRecevable',
    dossierNonRecevableBatchRequest: '/api/dossiers/batchDossierNonRecevable',
    dossierRecevable: '/api/dossiers/dossierRecevable',
    dossierRecevableBatchRequest: '/api/dossiers/batchDossierRecevable',
    dossierReouvertureSaisieRequest: '/api/dossiers/reouvertureSaisie',
    dossierReouvertureSaisieBatchRequest: '/api/dossiers/batchReouvertureSaisie',
    dossierAbandonSaisie: '/api/dossiers/abandonCandidat',
    dossierAjustementRequest: '/api/dossiers/ajustement',
    dossierCalculLiensInterets: '/api/dossiers/calcul_liens_interets',
    dossierCountPerAideAndStatut: '/api/statistics/dossiers_count_per_aide_and_statut/dossiers_count_per_aide_and_statut',
    dossierCountPerAideTypeAndStatut: '/api/statistics/dossiers_count_per_aide_type_and_statut/dossiers_count_per_aide_type_and_statut',
    dossierExpertsCountPerAideAndEtat: '/api/statistics/dossier_experts_count_per_aide_and_statut/dossier_experts_count_per_aide_and_statut',
    batchNomination : '/api/dossier_experts/batch_nomination',
    validationWorkflowAAP: '/api/aides/validation_workflow',
    tags: '/api/tags',
    desistementAdmin: '/api/dossiers/desistementAdmin',
    faqPublic: '/api/faqs?pagination=false&faqThemes.label={tagPublic}',
    faq: '/api/faqs?pagination=false',
    faqItem: '/api/faqs',
    theme: '/api/faq_themes',
    departements: '/api/departements',
    regions: '/api/regions',
    organizations: '/api/organizations',
    dossierSetOrganization: '/api/dossier_set_organization',
    dossierAnnulationChoixOrganization: '/api/dossier_annulation_choix_organization',
    aideFinancement: '/api/aide_financements',
    dossierFinancementStoreDocumentRequest: '/api/dossiers/dossier_financement_store_document',
    declarationLienInteret: '/api/declaration_lien_interets',
    csos: '/api/cso_classifications',
    canceropoles: '/api/canceropoles',
    riph: '/api/riphs',
    autreSoutienFinancier: '/api/autre_soutien_financiers',
    personnelRecrute: '/api/personnel_recrutes',
    publicationType: '/api/publication_types',
    congres: '/api/congres',
    rapportScientifiqueMasters: '/api/rapport_scientifique_masters',
    calendrier: '/api/calendriers',
    tableCalcul: '/api/table_calculs',
    cofinanceurs: '/api/co_financeurs',
    demandeProlongation: '/api/demande_prolongations',
    rapportScientifique: '/api/rapport_scientifiques',
    voirRapportScientifique: '/{langue}/rapport_scientifiques/{id}'
};
